import { Component } from '@angular/core';
import {EbsWebService} from "../../services/ebsWebService";
import {ViewController} from "ionic-angular";

@Component({
  selector: 'detail-popover-menu',
  templateUrl: 'detailPopoverMenu.html',
  providers: [EbsWebService]
})
export class DetailPopoverMenu {

  selectedItem:any;

  constructor(public viewCtrl: ViewController) {
    this.selectedItem = this.viewCtrl.data;
  }

  close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/detailPopoverMenu/detailPopoverMenu.ts